export type HubspotConversationExportType = 'activity' | 'inbox'

export interface HubspotInboxExportBulkItem {
    conversationId: string
    linkedinUrl?: string | null
    userEmail?: string | null
    isSales?: boolean
    connectionId?: string
    participants: any[]
}

export interface HubspotConversationExportModalPayload {
    bulk?: boolean
    isSales?: boolean
    conversationId?: string
    userEmail?: string | null
    linkedinUrl?: string | null
    connectionId?: string
    participants?: any[]
    /** Snapshot when opening modal (extension passes store messages). */
    messages?: any[]
    items?: HubspotInboxExportBulkItem[]
}

export const createHubspotMessagePreview = (message: any): string => {
    const parts: string[] = []

    if (message.text?.trim()) {
        parts.push(message.text.trim())
    }
    if (message.gif) {
        parts.push('[GIF]')
    }
    if (message.forwardedMessage) {
        parts.push('[Forwarded Message]')
    }
    if (message.attachments?.length > 0) {
        const attachmentNames = message.attachments
            .map((att: any) => att.name || 'Attachment')
            .join(', ')
        parts.push(`[${message.attachments.length} attachment(s): ${attachmentNames}]`)
    }
    if (message.audioAttachments?.length > 0) {
        parts.push(`[${message.audioAttachments.length} audio clip(s)]`)
    }
    if (parts.length === 0) {
        return '(No text content)'
    }
    return parts.join(' ')
}

export const normalizeLinkedinUrl = (url: string | null | undefined): string | null => {
    if (!url) return null
    return url.endsWith('/') ? url : `${url}/`
}

export const linkedinUrlFromParticipant = (participant: any): string | null => {
    if (!participant?.publicIdentifier) return null
    return `https://www.linkedin.com/in/${participant.publicIdentifier}/`
}

export const buildBulkHubspotExportItems = (
    conversations: any[],
    isSales: boolean
): HubspotInboxExportBulkItem[] =>
    conversations.map(conv => {
        const participants = Array.isArray(conv?.participants) ? conv.participants : []
        let linkedinUrl: string | null = null
        if (participants.length === 1) {
            linkedinUrl = linkedinUrlFromParticipant(participants[0])
        }
        return {
            conversationId: conv.conversationId,
            linkedinUrl,
            isSales,
            connectionId: conv.connectionId,
            participants: [...participants],
        }
    })
